// Fonte da verdade da conectividade do app.
// Combina dois sinais independentes:
//  - browserOnline: o navegador tem rede? (navigator.onLine + eventos online/offline)
//  - backendReachable: o backend respondeu à última requisição? (alimentado pelo interceptor do axios)
// Exposto via useSyncExternalStore no hook useConnectivity.

let state = {
  browserOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  backendReachable: true,
};

const listeners = new Set();

function computeSnapshot() {
  const isOffline = !state.browserOnline || !state.backendReachable;
  return {
    browserOnline: state.browserOnline,
    backendReachable: state.backendReachable,
    isOffline,
  };
}

// Snapshot em cache para manter a referência estável entre renders
// (exigência do useSyncExternalStore: só muda quando o estado realmente muda).
let cachedSnapshot = computeSnapshot();

function setState(patch) {
  const next = { ...state, ...patch };
  if (
    next.browserOnline === state.browserOnline &&
    next.backendReachable === state.backendReachable
  ) {
    return;
  }
  state = next;
  cachedSnapshot = computeSnapshot();
  listeners.forEach((listener) => listener());
}

// Chamado pelo interceptor quando uma requisição obtém resposta do backend.
export function reportBackendReachable() {
  setState({ backendReachable: true });
}

// Chamado pelo interceptor quando o backend não respondeu (timeout/rede).
export function reportBackendUnreachable() {
  setState({ backendReachable: false });
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot() {
  return cachedSnapshot;
}

// Eventos de rede do navegador.
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => setState({ browserOnline: true }));
  window.addEventListener('offline', () => setState({ browserOnline: false }));
}
